import styled, { css } from 'styled-components';
import cssKit from '../../css';

// Variable to detect if we are on a nissan or infiniti page and style accordingly
const nissan = process.env.BRAND_NAME === 'nissan';

export const StyledDisclaimerWrapper = styled.span`
  position: relative;
  display: inline-block;
  outline: none;
  display: inline-block !important;
  height: 25px;
`;

export const StyledDisclaimerContent = styled.span`
  bottom: 20px;
  left: 35px;
  z-index: 1010;
  position: absolute;
  bottom: 150%;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  border: 1px solid #d3d3d3;
  z-index: 1010;
  display: block;
  width: 325px;

  /* tooltip stem */
  &:after,
  &:before {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-top-color: #ffffff;
    border-width: 12px;
    margin-left: -12px;
  }
  &:before {
    border-color: rgba(211, 211, 211, 0);
    border-top-color: #d3d3d3;
    border-width: 13px;
    margin-left: -13px;
  }

  &[aria-hidden=true] {
    display: none;
  }

  &[aria-hidden=false] {
    display: block;
    width: 325px;
  }
`;

export const StyledDisclaimerText = styled.span`
  display: block;
  line-height: 1rem;
  margin: 15px !important;
  font-size: 0.7rem;
  font-family: ${cssKit.fonts.regular};
  text-transform: none;
  font-weight: ${nissan ? 'normal' : '200'};
  font-style: normal;

  /* INFINITI */
  /* font-family: 'infiniti-thin', arial, helvetica, verdana, sans-serif; */
`;

export const StyledDisclaimerButton = styled.button`
  float: left;
  position: relative;
  top: -4px;
  ${nissan && css`
    font-size: 0.75rem;
    vertical-align: super;
  `}
`;

export const StyledModalOverlay = styled.span`
  position: fixed;
  z-index: 1003;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0,0);
`;

export const StyledDisclaimerImage = styled.img`
  opacity: 0.5;
  width: 22px;
  height: 22px;

  ${!nissan && css`
    position: relative;
    top: -4px;
  `}
`;



/** WEBPACK FOOTER **
 ** ./src/components/Disclaimer/styles.js
 **/